export default {"src":"/uk/_next/static/media/spot-piggy-bank.f723223a.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};